// extracted by mini-css-extract-plugin
export default {"cta":"kI-z","disabled":"lI-z"};